import React, { useState } from "react";
import "./OptionFont.css";
import FontComponent from "./FontComponent/FontComponent";
import { useSelector } from "react-redux";
const Fonts = ({ isCard }) => {
  const [open, setOpen] = useState(null);
  const currentBlockType = useSelector(
    (s) =>
      s?.project?.credits[s?.project?.currentBlock.idx]?.options?.block_type
  );
  const commonFonts = ["heading", "subHeading"];
  const fontBlockMapper = {
    rolename: [...commonFonts, "role", "name"],
    nameonly: [...commonFonts, "name"],
    logo: [...commonFonts, "logo"],
    blurb: [...commonFonts, "blurb"],
    song: [...commonFonts, "songTitle", "songDetails"],
  };
  const allfontTypes = [
    { type: "heading", label: "Heading" },
    { type: "subHeading", label: "Sub Heading" },
    { type: "role", label: "Role" },
    { type: "name", label: "Name" },
    { type: "blurb", label: "Blurb" },
    // { type: "logo", label: "Logo" },
    { type: "songTitle", label: "Song Title" },
    { type: "songDetails", label: "Song Details" },
  ];

  const visibleFontTypes = allfontTypes.filter((font) => {
    return fontBlockMapper[currentBlockType]
      ? fontBlockMapper[currentBlockType].includes(font.type)
      : true;
  });
  return (
    <div className="option-font">
      {visibleFontTypes?.map(({ type, label }) => (
        <FontComponent
          type={type}
          label={label}
          currentOpen={open}
          setOpen={setOpen}
          currentBlockType={currentBlockType}
          isCard={isCard}
        />
      ))}
    </div>
  );
};

export default Fonts;
